import { Component, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { LinkService } from './common/core/services/link.service';
import { Meta } from '@angular/platform-browser';

@Component({
  template: '',
})
export class CoreComponent implements OnDestroy {
  protected garbageCollector: Subscription[] = [];
  protected linkService = inject(LinkService);
  protected meta = inject(Meta);

  ngOnDestroy() {
    for (const subscription of this.garbageCollector) {
      subscription.unsubscribe();
    }
  }

  trackConversion(gtag: string, transactionId?: string) {
    if (!!environment.gtm) {
      (<any>window).gtag('event', 'conversion', {
        send_to: `AW-11371316789/${gtag}`,
        transaction_id: transactionId,
      });
    }
  }

  updateCanonicalLink(newCanonicalUrl: string) {
    this.linkService.updateCanonicalLink(newCanonicalUrl);
  }

  get phone(): string {
    return environment.contact.phone;
  }

  get phoneInternational(): string {
    return environment.contact.phoneInternational;
  }

  get phoneRaw(): string {
    return environment.contact.phoneRaw;
  }

  get email(): string {
    return environment.contact.email;
  }
}
